export default "__VITE_ASSET__BEHyoQqo__"